import React, {Component, useState} from 'react';
import Notification from "./Notification";
import { connect } from 'react-redux';


class Notifications extends Component {
    constructor(props) {
        super(props);
        this.state = {

            unread: JSON.parse(this.props.unread),
        };
    }

    componentDidMount() {
        const newCount = this.state.unread.length
        this.props.updateNotificationCount(newCount)
    }
    onHandleClick(){
        this.props.toggleNotifications()
    }
    render() {
        const notifs = this.state.unread.map((notif, index )=>{

            return (
                    <Notification key={index} notif={notif} />
             )
            }
        )
       /* return (

            <div style={{'display': this.props.displayMe, 'position': 'absolute', 'top':'150px', 'left': '3rem', 'maxWidth': '20rem'}}>
                <div className="card bg-dark mb-2">
                    <button className="btn btn-outline-light btn-sm p-0 px-1 mr-1 mt-1 d-inline-flex align-self-end" onClick={this.onHandleClick.bind(this)}><i className="fas fa-times"></i></button>
                    <div className="card-header flex align-items-end">
                        <h4 className="d-inline-flex mr-2 text-primary"><i className="far fa-bell eu-btn-icon text-white  mr-2"></i> Mes notifications <sup>({this.props.unreadNb})</sup></h4>
                    </div>
                </div>
                {(this.props.unreadNb > 0)
                    ? notifs
                    : <div className={'card bg-dark'}>
                        <div className={'card-body text-center'}>
                            <p className={'py-2'}>Vos n'avez pas de notification non lu !</p>
                            <button className={'btn btn-outline-primary'}
                                    onClick={this.onHandleClick.bind(this)}>fermer
                            </button>
                            <hr/>
                            <a href="/dashboard/notifications">Visualiser toutes les notifications</a>
                        </div>
                    </div>
                }
            </div>
        );*/
    }
}


const mapStateToProps = state => {
    return {
        unreadNb: state.NotificationReducer.counter,
        displayMe : state.NotificationReducer.display
    }
}


const mapDispatchTProps = dispatch => {
    return {
        updateNotificationCount : (e) => dispatch({type:'UPDATE_NOTIFICATIONS_COUNT', value: e}),
        toggleNotifications: () => dispatch( {type: 'TOGGLE_NOTIFICATIONS'})

    }
}

export default connect(mapStateToProps, mapDispatchTProps)(Notifications);

